<template>
	<div class="flex w-full max-w-105 flex-col items-center justify-center gap-2 px-4 text-center">
		<div
			v-if="iconName"
			class="bg-secondary text-secondary mb-2 flex size-8 items-center justify-center rounded-full"
			:class="{
				'size-16': iconSize === 'large',
				'size-12': iconSize === 'medium',
				'size-8': iconSize === 'small',
				'mb-5': iconSize === 'large',
				'mb-3.5': iconSize === 'medium',
				'mb-2': iconSize === 'small'
			}"
		>
			<Icon :name="iconName" :size="iconSize === 'large' ? 32 : iconSize === 'medium' ? 24 : 16" />
		</div>
		<div v-else class="relative flex w-full flex-col items-center justify-center pb-12">
			<ActionCard placeholder bordered class="absolute! top-8 w-full max-w-11/12 rounded-2xl!" />
			<ActionCard placeholder bordered class="relative z-1 w-full rounded-2xl! shadow-xl" />
		</div>
		<div class="leading-tight font-semibold">{{ subtitle }}</div>
		<div class="text-secondary text-sm">{{ title }}</div>
		<slot />
	</div>
</template>

<script setup lang="ts">
import ActionCard from "@/components/common/ActionCard.vue"
import Icon from "@/components/common/Icon.vue"

const { title, subtitle, iconName, iconSize } = defineProps<{
	title?: string
	subtitle?: string
	iconName?: string
	iconSize?: "small" | "medium" | "large"
}>()
</script>
